<template>
  <div>

    <el-table :data="dt2table1" border class="tb-edit" style="width: 100%" ref="multipleTable" :header-cell-style="{'text-align':'center'}">

      <el-table-column label="名称" width="180" prop="cpasturename">
      </el-table-column>
      <el-table-column label="规格" width="80" prop="cbid">
      </el-table-column>
      <el-table-column label="计量单位" width="80" prop="cunit_price">
      </el-table-column>
      <el-table-column label="数量" width="80" prop="ipricenum">
      </el-table-column>
      <el-table-column v-for="(item,i) in tableHead" :key="i" :label="item.label" :property="item.property" width="180">
        <template slot-scope="scope" v-if="item.child.length==0">
          {{scope.row[scope.column.property]}}
        </template>
        <template v-if="item.child.length!=0">
          <el-table-column v-for="(temchild,index) in item.child" :key="index" :label="temchild.label" :property="temchild.property" width="120">
          </el-table-column>

        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
export default {
  props: {
    dt2table1: { type: Array },
    tableHead: { type: Array },
  },
  name: "ruleTable",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
